<template>
  <div class="wrapper-base-notification-list">
    <div class="header">
      <div v-if="title">
        <strong>{{ title }}</strong>
      </div>
      <div>
        <button
          v-if="isShowReadAllButton"
          class="btn btn-light btn-sm btn-read-all"
          @click="handleClickReadAll()">
          {{ $t('message.readall') }}
        </button>
      </div>
    </div>
    <ul class="body">
      <li
        v-for="(item, index) in limitItemList"
        :key="index"
      >
        <slot
          :itemData="item"
          name="item"/>
      </li>
    </ul>
    <div
      v-if="isShowSeeMoreButton"
      class="footer">
      <button
        class="btn btn-light btn-sm"
        @click="handleClickSeeMore()">
        {{ $t('message.seemorewithnumber', { number: seeMoreCount }) }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
    },
    items: {
      type: Array,
      default: () => ([]),
    },
    limitItems: {
      type: Number,
      default: 10,
    },
  },

  data() {
    return {
      isClickedViewAll: false,
    }
  },

  computed: {
    limitItemList() {
      if (this.isClickedViewAll) {
        return this.items
      }
      return this.items.reduce((acc, cur) => {
        if (acc.length < this.limitItems) {
          acc.push(cur)
        }
        return acc
      }, [])
    },
    isShowReadAllButton() {
      return this.items.some((item) => !item.is_read)
    },
    isShowSeeMoreButton() {
      return !this.isClickedViewAll && this.items.length > this.limitItems
    },
    seeMoreCount() {
      return this.items.length - this.limitItems
    },
  },

  methods: {
    handleClickReadAll() {
      this.$emit('onClickReadAll')
    },
    handleClickSeeMore() {
      // fixed: "v-click-outside" will trigger without setTimeout
      setTimeout(() => {
        this.isClickedViewAll = true
      }, 50)
    },
  },
}
</script>

<style scoped>
.wrapper-base-notification-list {
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  flex: row;
  justify-content: space-between;
  align-items: center;
  padding: 15px 15px;
  border-bottom: 1px solid #F2F2F2;
}

.header .btn-read-all {
  margin-right: 27px;
}

ul.body {
  margin: 0;
}

ul.body li {
  padding: 10px 15px;
  border-bottom: solid 1px #F2F2F2;
}

ul.body li >>> .title {
  flex: 1;
}

ul.body li >>> .action {
  min-width: 250px;
  width: 250px;
}

.footer {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/base/BaseNotificationList.vue